export default __webpack_public_path__ + "static/media/NTEX CLASS-6 EXAM PATTERN 2025.759ec365.pdf";